<style scoped lang="sass">
form
  box-shadow: none
  .subscription-date
    margin-bottom: 1rem
  .card-info
    margin-bottom: 1rem
  .amount-select
    margin-bottom: 0.3rem
  .buttons
    display: flex
    justify-content: space-between
    >:first-child
      margin-right: 0.5rem
      flex-grow: 2
      width: auto
    >:last-child
      flex-grow: 1
      width: auto
  .stripe-logo
    float: right
    margin-top: 0.5rem
</style>
<template>
  <pinhigh-modal @close="$emit('close')" :disable-backdrop-close="true">
    <form @submit.prevent="pay">
      <div class="subscription-date">
        <span v-if="$root.currentUserSolvent">Subscription ends: {{$root.currentUserSolventThrough}}</span>
        <span v-else>Not subscribed</span>
      </div>
      <div class="card-info">
        <div v-if="$root.currentUser.stripe_customer_id">
          Card: XXXX-XXXX-XXXX-{{$root.currentUser.stripe_card_last_4}}
          <span>
            <a href="#" @click.prevent="confirmRemoveCard" v-if="!confirmedRemoveCard">Remove?</a>
            <a href="#" @click.prevent="removeCard" v-else>Remove Now!</a>
          </span>
        </div>
        <div v-else>
          <card
            :stripe="$root.stripePublishableKey"
            @change="complete = $event.complete"
            :options="cardOptions"
            v-if="!$root.currentUser.stripe_customer_id"
            ></card>
        </div>
      </div>
      <pinhigh-select :options="amountOptions" v-model="amount" class="amount-select"></pinhigh-select>
      <div class="buttons">
        <div v-if="!confirmed">
          <button :disabled="!complete" class="button positive" @click.prevent="confirming = true" v-if="!confirming">Pay ${{amount}}</button>
          <input type="submit" :disabled="!complete" class="button positive" :value="`Confirm $${amount}!`" v-if="confirming">
        </div>
        <div v-else>
          <a href="#" @click.prevent="" class="button boring">Processing...</a>
        </div>
        <a href="#" @click.prevent="close" class="button boring">Close</a>
      </div>
      <img src="../assets/images/stripe-logo.svg" class="stripe-logo">
    </form>
  </pinhigh-modal>
</template>
<script>
import { Card, createToken }        from 'vue-stripe-elements-plus';

import api                          from '../api';

export default {
  name: 'PaymentModal',
  components: {
    Card
  },
  data() {
    return {
      confirmedRemoveCard: false,
      confirming: false,
      confirmed: false,
      amount: 2,
      amountOptions: [
        {value: 2, label: '$2 for 1 Month'},
        {value: 4, label: '$4 for 2 Months'},
        {value: 6, label: '$6 for 3 Months'},
        {value: 9.99, label: '$9.99 for 1 Year'}
      ],
      complete: !!this.$root.currentUser.stripe_customer_id,
      cardOptions: {
        style: {
          base: {
            fontSize: '18px',
            '::placeholder': {
              color: 'rgba(63, 158, 71, 0.7)'
            }
          }
        }
      }
    };
  },
  computed: {
    amountCents() {
      return this.amount * 100;
    }
  },
  methods: {
    confirmRemoveCard() {
      this.confirmedRemoveCard = true;
    },
    async removeCard() {
      this.$store.dispatch('destroyStripeCard', {params: {id: this.$root.currentUser.id}});
      const user = await api.User.show({params: {id: this.$root.currentUser.id}});
      await this.$store.commit('logIn', user);
    },
    close() {
      this.$emit('close');
    },
    async pay() {
      this.confirmed = true;
      let payment = null;
      if (this.$root.currentUser.stripe_customer_id) {
        payment = await api.Payment.create({params: {
          payment: {amount: this.amountCents}
        }});
      } else {
        const data = await createToken();
        payment = await api.Payment.create({params: {
          user: {stripe_card_id: data.token.card.id, stripe_card_last_4: data.token.card.last4},
          payment: {amount: this.amountCents},
          token: data.token.id
        }});
      }
      const user = await api.User.show({params: {id: this.$root.currentUser.id}});
      await this.$store.commit('logIn', user);
      await this.$store.dispatch('updateDashboardPools');
      await this.$ga.ecommerce.addItem({
        id: payment.stripe_transaction_id,
        name: 'Subscription',
        price: payment.amount / 100,
        quantity: 1,
        sku: 'sku-subscription'
      });
      await this.$ga.ecommerce.addTransaction({
        id: payment.stripe_transaction_id,
        revenue: payment.amount / 100
      });
      await this.$ga.ecommerce.send({});
      this.close();
    }
  }
};
</script>
